module.exports = __webpack_public_path__ + "media/images/fake_courses/test3-9e352c2f8f091bc7c49538fc1aa632f7.jpg";